<template>
  <div class="container mt-5">
    <div class="card p-4 shadow border-0" style="border-radius: 16px;">
      <h4 class="mb-4" style="color: #b03a45;">Edit Contract</h4>

      <form @submit.prevent="handleUpdate">
        <div class="row">
          <!-- Reference -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label class="form-label">Reference</label>
              <input type="text" class="form-control border-0" v-model="form.reference" required />
            </div>
          </div>

          <!-- User -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label class="form-label">User</label>
              <select v-model="form.user_id" class="form-select border-0" required>
                <option disabled value="">Select user</option>
                <option v-for="user in users" :key="user.id" :value="user.id">
                  {{ user.firstname }} {{ user.lastname }}
                </option>
              </select>
            </div>
          </div>

          <!-- Contract Type -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label class="form-label">Contract Type</label>
              <select v-model="form.contract_type_id" class="form-select border-0" required>
                <option disabled value="">Select type</option>
                <option v-for="type in contractTypes" :key="type.id" :value="type.id">
                  {{ type.name }}
                </option>
              </select>
            </div>
          </div>

          <!-- Start Date -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label class="form-label">Start Date</label>
              <input type="date" class="form-control border-0" v-model="form.start_date" required />
            </div>
          </div>

          <!-- End Date -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label class="form-label">End Date</label>
              <input type="date" class="form-control border-0" v-model="form.end_date" />
            </div>
          </div>

          <!-- Monthly Salary -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label class="form-label">Monthly Salary (Net)</label>
              <input type="number" class="form-control border-0" v-model="form.monthly_salary_net" />
            </div>
          </div>
        </div>

        <!-- Submit -->
        <div class="text-end">
          <button type="submit" class="btn text-white px-4" style="background-color: #b03a45;">
            Save Changes
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from '@/api'
import { useToast } from 'vue-toastification'

export default {
  name: 'ModifierContract',
  data() {
    return {
      form: {
        reference: '',
        user_id: '',
        contract_type_id: '',
        start_date: '',
        end_date: '',
        monthly_salary_net: ''
      },
      users: [],
      contractTypes: [],
      toast: useToast()
    }
  },
  async created() {
    const id = this.$route.params.id
    try {
      const [{ data }, usersRes, typesRes] = await Promise.all([
        axios.get(`/employee/contracts/${id}`),
        axios.get('/getAllUser'),
        axios.get('/contract-types')
      ])
      this.form = data.data
      this.users = usersRes.data.data || []
      this.contractTypes = typesRes.data || []
    } catch (e) {
      this.toast.error('Failed to load contract data')
    }
  },
  methods: {
    async handleUpdate() {
      const id = this.$route.params.id
      try {
        await axios.put(`/employee/contracts/${id}`, this.form)
        this.toast.success('Contract updated successfully')
        this.$router.push('/contracts')
      } catch (e) {
        this.toast.error('Failed to update contract')
      }
    }
  }
}
</script>
